import React from 'react';
import PropTypes from 'prop-types';

const ProgressDot = (props) => {
    const Tag = props.tag;
    const { tag, label, active, light, variation, ...safeProps } = props;
    return (
        <Tag
            {...safeProps}
            className={`
                progress-dot
                progress-dot--${variation}
                ${light ? 'progress-dot--light' : ''}
                ${active ? '-active' : ''}
                ${props.className}
            `}>
            {label}
        </Tag>
    );
};

ProgressDot.propTypes = {
    className: PropTypes.string,
    tag: PropTypes.string,
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
    variation: PropTypes.oneOf(['normal', 'alt']),
    light: PropTypes.bool,
};

ProgressDot.defaultProps = {
    className: '',
    tag: 'button',
    active: false,
    light: false,
    variation: 'normal',
};

const ProgressDots = (props) => {
    let dots = [];
    for (let i = 0, l = props.total; i < l; i++) {
        dots.push(
            <ProgressDot
                key={i}
                className={
                    props.className ? `${props.className}__dot` : undefined
                }
                tag={props.tag}
                label={props.label ? `${props.label} ${i + 1}` : i + 1}
                onClick={(e) => {
                    e.preventDefault();
                    props.onDotClick(i);
                }}
                active={props.current === i}
                variation={props.variation}
                light={props.light}
            />,
        );
    }

    const {
        tag,
        total,
        current,
        light,
        label,
        variation,
        onDotClick,
        ...safeProps
    } = props;

    return dots.length > 0 ? (
        <div
            {...safeProps}
            className={`
                progress-dots
                progress-dots--${variation}
                ${light ? 'progress-dots--light' : ''}
                ${props.className}
            `}>
            {dots}
        </div>
    ) : null;
};

ProgressDots.propTypes = {
    className: PropTypes.string,
    tag: PropTypes.string,
    total: PropTypes.number.isRequired,
    current: PropTypes.number,
    onDotClick: PropTypes.func,
    light: PropTypes.bool,
    label: PropTypes.string,
    variation: PropTypes.oneOf(['normal', 'alt']),
};

ProgressDots.defaultProps = {
    className: '',
    tag: 'button',
    total: 0,
    current: 0,
    onDotClick: () => {},
    light: false,
    label: '',
    variation: 'normal',
};

export { ProgressDot };
export default ProgressDots;
